import React, { useState, useRef, useEffect } from 'react'
import '../styles/Photo.css'

const BASE_URL = 'https://api.admin.yourhood.ge'

function Photo() {
  const [currentHero, setCurrentHero] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')
  const inputRef = useRef()

  const token = localStorage.getItem('token')

  useEffect(() => {
    fetch(`${BASE_URL}/api/Hero/hero`, {
      headers: { 'X-Language': 'ka', 'Authorization': token }
    })
      .then(r => r.json())
      .then(data => { if (data.imageUrl) setCurrentHero(data.imageUrl) })
      .catch(() => {})
  }, [])

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0]
    if (!file) return

    setIsLoading(true)
    setError('')
    setSuccess('')

    try {
      // Step 1: Upload image
      const formData = new FormData()
      formData.append('images', file)
      formData.append('imageType', '0')

      const uploadRes = await fetch(`${BASE_URL}/api/ImageUpload/upload`, {
        method: 'PUT',
        headers: { 'X-Language': 'ka', 'Authorization': token },
        body: formData
      })

      if (!uploadRes.ok) {
        const d = await uploadRes.json().catch(() => null)
        throw new Error(d?.message || 'ატვირთვა ვერ მოხერხდა')
      }

      const uploaded = await uploadRes.json()
      const image = Array.isArray(uploaded) ? uploaded[0] : uploaded

      // Step 2: Set as hero immediately
      const heroRes = await fetch(`${BASE_URL}/api/Hero/edit-hero?ImageID=${image.id}`, {
        method: 'PUT',
        headers: { 'X-Language': 'ka', 'Authorization': token, 'accept': '*/*' },
      })

      if (!heroRes.ok) {
        const d = await heroRes.json().catch(() => null)
        throw new Error(d?.message || 'განახლება ვერ მოხერხდა')
      }

      setCurrentHero(image.imageLink)
      setSuccess('მთავარი გვერდის ფოტო განახლდა!')
    } catch (err) {
      setError(err.message || 'შეცდომა. სცადეთ თავიდან.')
    } finally {
      setIsLoading(false)
      if (inputRef.current) inputRef.current.value = ''
    }
  }

  return (
    <div className="ph-wrapper">

      <div className="ph-header">
        <h2 className="ph-title">მთავარი გვერდის ფოტო</h2>
        <p className="ph-subtitle">Landing page-ზე გამოსახული სურათი</p>
      </div>

      {success && <div className="ph-success">{success}</div>}
      {error && <div className="ph-error">{error}</div>}

      {/* ── Current hero ── */}
      <div
        className={`ph-hero-zone ${isLoading ? 'ph-hero-zone--loading' : ''}`}
        onClick={() => !isLoading && inputRef.current?.click()}
      >
        <input
          ref={inputRef}
          type="file"
          accept="image/*"
          className="ph-input-hidden"
          onChange={handleFileChange}
        />

        {currentHero && (
          <img src={currentHero} alt="hero" className="ph-hero-img" />
        )}

        <div className="ph-hero-overlay">
          {isLoading ? (
            <span className="ph-hero-overlay-text">იტვირთება...</span>
          ) : (
            <span className="ph-hero-overlay-text">
              {currentHero ? 'ფოტოს შეცვლა' : 'ფოტოს არჩევა'}
            </span>
          )}
        </div>
      </div>

      <p className="ph-hint">დააჭირეთ სურათს შესაცვლელად — ატვირთვისთანავე განახლდება</p>

    </div>
  )
}

export default Photo